import { useContext, useEffect, useState } from "react";
import { 
    AppSpan, Button, CenterPopupContainer, Form, FormGroup,
    CustomContainer, FixedContainer, FlexRow, ScreenTitle, FormGroupWithIcon 
} from "src/style"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { NewCompanyLayout } from 'src/component'
import { useNotifier } from "react-pop-notifier"
import { FiChevronDown } from "react-icons/fi";

export const NewCompanyBasicDetails: React.FC<any> = ({next, close}) => {
    const {notifier} = useNotifier()
    const {info: {companyCreationProcess}, setInfoProperty} = useContext(AppInfoContext)
    const [input, setInput] = useState({
        firstName: '', lastName: '', name: '',  
        phoneNumber: '', email: '', age: '',
        gender: ''
    })

    useEffect(() => {
        if (companyCreationProcess) {
            const {firstName, lastName, phoneNumber, email, name, gender, age} = companyCreationProcess
            setInput({
                ...input, 
                firstName, 
                lastName, 
                phoneNumber, 
                email,
                name,
                gender,
                age
            }) 
        }
    }, [companyCreationProcess])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleNext(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
    
        await setInfoProperty('companyCreationProcess', {...companyCreationProcess, ...input, basicDetails: true})
        next()
    }

    return (
        <>
            <CenterPopupContainer onClick={close} />
            <FixedContainer
                top="50" tSizeUnit="%" 
                left="50" lSizeUnit="%"
                bgColor="#ffffff" zIndex='9'
                height='82.6' width='123.6'
                radius='0.8'
                className="popup-container-lg"
            >
                <NewCompanyLayout currentScreen='basic-details'>
                    <CustomContainer bottomMargin="2.5">
                        <ScreenTitle 
                            textSize="2" color="#111111" 
                            fontWeight="600"
                        >
                            Set Up basic details for the Company
                        </ScreenTitle>
                        <AppSpan textSize="1.6" color="#4F4F4F">
                            Orci, porttitor feugiat sociis quis pellentesque non morbi. 
                            Ultricies mi dignissim lorem in. Vitae aliquet gravida sed massa dolor.
                        </AppSpan>
                    </CustomContainer>
                    <Form topMargin='3' onSubmit={handleNext}>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>Company Name</label>
                                <input 
                                    placeholder='Enter Company Name' 
                                    name='name'
                                    value={input.name}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>email</label>
                                <input 
                                    placeholder='Enter email' 
                                    name='email'
                                    type='email'
                                    value={input.email}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>First Name</label>
                                <input 
                                    placeholder='Enter First Name' 
                                    name='firstName'
                                    value={input.firstName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Last Name</label>
                                <input 
                                    placeholder='Enter Last Name' 
                                    name='lastName'
                                    value={input.lastName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>Phone Number</label>
                                <input 
                                    placeholder='Enter Phone Number' 
                                    name='phoneNumber'
                                    value={input.phoneNumber}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Age</label>
                                <input 
                                    placeholder='Enter Age' 
                                    name='age'
                                    value={input.age}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroupWithIcon bottomMargin="0">
                                <label>Gender</label>
                                <div 
                                    style={{height: '5.5rem'}}
                                    className="input-with-icon"
                                >
                                    <select 
                                        name='gender'
                                        value={input.gender}
                                        onChange={handleInput}
                                        style={{height: '5.5rem'}}
                                        autoComplete='off'
                                    >
                                        <option value="">--Select--</option>
                                        <option value='Male'>Male</option>
                                        <option value='Female'>Female</option>      
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                        </FlexRow>

                        <FlexRow 
                            justifyContent='flex-end'
                            gap="1" topMargin='5'
                        >
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff'
                                bgColor="#ffffff" 
                                hoverBorderColor='#5627FF'
                                hoverColor='#5627FF'
                                color="#5627FF"
                                onClick={close}
                            >
                                Back
                            </Button>
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff' 
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                            >
                                Next
                            </Button>
                        </FlexRow>
                    </Form>
                </NewCompanyLayout>
            </FixedContainer>
        </>
    )
}